import Modal from 'react-modal';
import React from 'react';

interface StyleProps {
  content: React.CSSProperties;
  overlay: React.CSSProperties;
}
interface StyledModalProps {
  isOpen: boolean;
  onRequestClose: () => void;
  label: string;
  style?: StyleProps;
  children: React.ReactNode;
}

export const StyledModal = (props: StyledModalProps) => {
  const { isOpen, onRequestClose, label, children, style } = props;
  const description = `${label}-description`;
  const modalStyle = style ?? {
    content: {
      paddingTop: 30,
      paddingBottom: 30,
      paddingLeft: 20,
      paddingRight: 20,
      display: 'flex',
      flexDirection: 'column',
      borderRadius: 8,
      minWidth: '26vw',
      position: undefined,
    },
    overlay: {
      backgroundColor: 'rgba(0,0,0,0.5)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 999,
    },
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      aria-labelledby={label}
      aria-describedby={description}
      aria-lalabel={label}
      style={modalStyle}
      ariaHideApp={false}
    >
      {children}
    </Modal>
  );
};
